export class ChangePassword {
    public userId: string;
    public oldPassword: string;
    public newPassword: string;

    constructor(userId: string) {
        this.userId = userId;
    }
}